import React from "react";
import "./HeaderComponent.css";

export default class WelcomeComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navigate: "welcome",
    };
    this.handleNavigate = this.handleNavigate.bind(this);
  }

  handleNavigate(value) {
    this.setState({ navigate: value });
  }

  render() {
    return (
      <div id="header">
        <nav className="fixed top-0 w-full bg-gray-950/90 backdrop-blur-sm border-b border-gray-800 z-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 py-4 flex items-center justify-between">
            <div className="font-semibold text-lg text-white">
              Sabarish Narain
            </div>
            <div className="hidden md:flex gap-8 items-center text-sm">
              <a
                href="#about"
                className="text-gray-400 hover:text-white transition"
              >
                About
              </a>
              <a
                href="#projects"
                className="text-gray-400 hover:text-white transition"
              >
                Products
              </a>
              <a
                href="#contact"
                className="text-gray-400 hover:text-white transition"
              >
                Contact
              </a>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}
